import React, { useState } from 'react'
import IcoMoonIcon from '@/components/themes/common/icons/IcoMoonIcon'
import ICON_MAP from '@/components/themes/common/icons/iconMapper'
import useTranslation from '@/hooks/useTranslation'
import styles from '@/components/themes/subaru/publications/publicationTopicRow.module.scss'
import localStyles from './searchTopicRow.module.scss'
import SearchModal from '@/components/themes/subaru/header/searchModal'

const SearchTopicRow = ({ brand, model, modelType, year, language, className = '' }) => {
  const [open, setOpen] = useState(false)
  const t = useTranslation()

  return (
    <>
      <div className={localStyles.searchTopicRow}>
        <div
          className={`${styles.publicationRow} ${className}`.trim()}
          onClick={() => setOpen(true)}
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              setOpen(true)
            }
          }}
        >
          <div className={styles.leftContent}>
            <div className={styles.iconWrapper}>
              <IcoMoonIcon className={styles.icon} icon={ICON_MAP.search} aria-hidden="true" />
            </div>
            <span className={styles.title}>
              {t('visual_search_use_search_prompt', "Can't find what you're looking for? Use Search")}
            </span>
          </div>

          <div className={styles.rightContent}>
            <IcoMoonIcon className={styles.chevron} icon={ICON_MAP.chevronRight} aria-hidden="true" />
          </div>
        </div>
      </div>

      <SearchModal
        open={open}
        onClose={() => setOpen(false)}
        brand={brand}
        model={model}
        modelType={modelType}
        year={year}
        language={language}
      />
    </>
  )
}

export default SearchTopicRow
